module.exports = __webpack_public_path__ + "static/media/mobile-2-1.34170970.gif";